export default "__VITE_ASSET__DcCZDwgp__"